//Remove the skip playback command from state after media has been skipped
export const clearPlaybackCommand = () => ({ type: 'CLEAR_PLAYBACK_COMMAND'})